import fundsClient from 'src/api/fundsClient';

const baseUrl = `${process.env.REACT_APP_FUNDS_API}${process.env.REACT_APP_NETDOCS_API_PATH}api/v1/`;

export const oauthLogin = async (authCode) => fundsClient.post(`${baseUrl}oauth/login`, { authCode });

export const hasActiveNetdocsLogin = async () => fundsClient.get(`${baseUrl}oauth/login`);

export const searchDocuments = async (_, { attributeType, resourceId }) => {
  const { data } = await fundsClient.get(`${baseUrl}search/${attributeType}/${resourceId}`);
  return data;
};
